import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'

// TODO stylize as per PR's guidelines

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: '0px 25px',
  backgroundColor: theme.palette.background.slider,
}))

export const ContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  maxWidth: '400px',
  margin: 'auto',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  fontFamily: theme.typography.fontFamily,
}))

export const ErrorTitle = styled('h2')(({ theme }) => ({
  margin: '0 0 8px 0',
  color: theme.palette.error.main,
}))

export const ErrorMessage = styled('p')(({ theme }) => ({
  margin: '0 0 24px 0',
  textAlign: 'center',
  color: theme.palette.error.main,
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  marginBottom: '16px',
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}))

export const Title = styled('h1')(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 'bold',
  color: theme.palette.text.primary,
}))

export const Subtitle = styled('h1')(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 400,
  color: theme.palette.text.secondary,
}))

export const Details = styled('h1')(({ theme }) => ({
  marginTop: '2rem',
  fontSize: '1rem',
  fontWeight: 600,
  color: theme.palette.error.main,
}))
